import type { ReactNode } from 'react';
import { useTranslation } from '@/i18n';
import type { LinkMode } from '@/pages/Import/Contract/logic/types';

/** Shared input styling of the import wizards (mirrors the netzplan steps). */
export const INPUT =
  'w-full px-2.5 py-1.5 rounded-md bg-white border border-slate-200 text-[13px] text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-[#00A871]/30 focus:border-[#00A871]/50';

/** Labelled field wrapper for the create-forms. */
export function Field({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div>
      <label className="block text-[12px] font-medium text-slate-600 mb-1">{label}</label>
      {children}
    </div>
  );
}

/** Link ↔ create segmented toggle. */
export function ModeToggle({ mode, onChange }: { mode: LinkMode; onChange: (mode: LinkMode) => void }) {
  const { t } = useTranslation('contractImport');
  const options: LinkMode[] = ['link', 'create'];
  return (
    <div className="inline-flex rounded-md border border-slate-200 overflow-hidden">
      {options.map((option) => (
        <button
          key={option}
          type="button"
          onClick={() => onChange(option)}
          aria-pressed={mode === option}
          className={`px-3 py-1.5 text-[12px] font-medium transition-colors ${
            mode === option
              ? 'bg-[#00A871] text-white'
              : 'bg-white text-slate-600 hover:bg-slate-50'
          }`}
        >
          {t(`actions.${option}`)}
        </button>
      ))}
    </div>
  );
}

/** Small mono kicker header used above the extraction summary blocks. */
export function Kicker({ children }: { children: ReactNode }) {
  return (
    <div className="text-[10px] font-mono uppercase tracking-[0.18em] text-slate-400">{children}</div>
  );
}
